import axios from 'axios'
import { Modal, Message, Spin } from 'view-design'
import cookie from 'vue-cookies';
import vue from "../main.js";

var API_URL = process.env.API_URL;
var spinHideTimeout = {}

const refreshIgnoreList = ["/get_vod_play_preview_urls", "get_vod_by_tagging","check_event", "query_recommend_broadcast_channels"]
function refreshIgnore(url) {
  // let flag = true
  // refreshIgnoreList.forEach(i => {
  //   flag = flag && request.url.indexOf(i) < 0
  // })
  return refreshIgnoreList.every(item => url.indexOf(item) < 0)
  // return flag
}
const ajaxRequest = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})
ajaxRequest.interceptors.request.use(
  request => {
    if( refreshIgnore(request.url)) {
      vue.$store.commit("add_ajax_spin")
      clearTimeout(spinHideTimeout)
      Spin.show();
    }

    if(request.url.indexOf("pw_login") < 0)
    {
      let kls_user_session = cookie.get("kls_user_session");
      request.headers["Token"] = kls_user_session;
    }
    return request;
  },
  error => {
    console.info(error);
  }
)
ajaxRequest.interceptors.response.use(
  async res => {
    // console.info('response',res);
    if(res.config.url.indexOf("/get_vod_play_preview_urls") < 0 && res.config.url.indexOf("get_vod_by_tagging") < 0) {
      vue.$store.commit("sub_ajax_spin")
      let ajax_count = vue.$store.getters.get_ajax_count
      if(ajax_count <= 0) {
        spinHideTimeout = setTimeout(() => {
          Spin.hide();
        }, 250)
      }
    }

    var data = res.data;
    //如果返回的是BLOB的内容，则直接返回
    if(res.request.responseType == "blob"){
      if(data.type == "application/json") {
        data = await data.text();
        console.info(data);
        data = JSON.parse(data);
      }else{
        return res.data;
      }
    }

    if(data.err_code == 0){
      return res.data;
    }else{
      if(data.unauthorized) {
        Message.error({
          content: vue.$t("errMsg['unauthorized']"),
          duration: 10,
          closable: true
        });
        setTimeout(() => {
          $cookies.keys().forEach(cookie => $cookies.remove(cookie));
          location.href = process.env.USER_PORTAL_URL;
        }, 3000);
        return;
      }else{
        Message.error({
          content: vue.$t("errMsg['" + data.err_message + "']"),
          duration: 10,
          closable: true
        });
        return Promise.reject(data)
      }
    }
  },
  error => {
    // console.info("error", error.response);
    vue.$store.commit("sub_ajax_spin")
    let ajax_count = vue.$store.getters.get_ajax_count
    if(ajax_count <= 0) {
      spinHideTimeout = setTimeout(() => {
        Spin.hide();
      }, 250)
    }
    Modal.error({
      title: "SYSTEM ERROR",
      content: JSON.stringify(error.response.data) + "<br/>YOU CAN TRY TO RELOAD THIS PAGE OR CONTACT WITH ADMIN",
      okText: "OK",
    });
    return Promise.reject(error.response.data)
  }
)

export default ajaxRequest



// WEBPACK FOOTER //
// ./src/api/ajax.js